import React from "react";
import Select from "react-select";
import {FaAnglesLeft, FaAnglesRight, FaChevronLeft, FaChevronRight} from "react-icons/fa6";

const Pagination = ({updateCurrentPage, requestParams, totalPages, totalElements}) => {
    const options = Array.from({length: totalPages}, (_, i) => ({
        value: i,
        label: (i + 1).toString(),
    }));

    const customStyles = {
        menu: (def) => ({...def, zIndex: 2000}),
        control: (base) => ({...base, minHeight: 25, height: 25}),
        valueContainer: (base) => ({...base, marginRight: '3px', marginLeft: '1px', paddingTop: '1px', height: 25}),
        input: (base) => ({...base, margin: 0, padding: 0}),
        singleValue: (base) => ({...base, lineHeight: '25px'}),
        indicatorsContainer: (base) => ({...base, height: 25}),
        option: (base) => ({...base, textAlign: 'center', paddingLeft: 8, color: 'black'}),
    };

    return (
        <>
            <div className={"flex justify-center items-center gap-2 w-full mt-2.5"}>
                <button className={"border-none cursor-pointer disabled:opacity-40 disabled:cursor-default"} disabled={requestParams.page === 0} onClick={() => updateCurrentPage(0)}>
                    <FaAnglesLeft className={"inline"}/>
                </button>
                <button className={"border-none cursor-pointer disabled:opacity-40 disabled:cursor-default"} disabled={requestParams.page === 0} onClick={() => updateCurrentPage(requestParams.page - 1)}>
                    <FaChevronLeft className={"inline"}/>
                </button>

                <Select
                    value={{value: requestParams.page, label: requestParams.page + 1}}
                    menuPlacement="top"
                    options={options}
                    isClearable={false}
                    onChange={(value) => updateCurrentPage(value.value)}
                    components={{DropdownIndicator: () => null, IndicatorSeparator: () => null}}
                    styles={customStyles}
                />

                <h4 className={"h-[33px] content-center"}>
                    / {totalPages}
                </h4>

                <button className={"border-none cursor-pointer disabled:opacity-40 disabled:cursor-default"} disabled={requestParams.page + 1 >= totalPages} onClick={() => updateCurrentPage(requestParams.page + 1)}>
                    <FaChevronRight className={"inline"}/>
                </button>
                <button className={"border-none cursor-pointer disabled:opacity-40 disabled:cursor-default"} disabled={requestParams.page + 1 >= totalPages} onClick={() => updateCurrentPage(totalPages - 1)}>
                    <FaAnglesRight className={"inline"}/>
                </button>
            </div>

            <div className={"flex justify-center items-center gap-2 mt-2.5"}>
                <h5 className={"mx-2.5 whitespace-nowrap"}>
                    Total: {totalElements}
                </h5>
            </div>
        </>
    );
};

export default Pagination;
